<div class='container pt-4'>


  <div *ngIf='!(authenticationService.userData)' name='user-login' class='list-container' required>
    <div class='form-group'>
      <mat-form-field class='w-100'>
        <input matInput [(ngModel)]='email' placeholder='Email address' name='email' type='email' class='w-100'
               id='email'
               aria-describedby='emailHelp'>
      </mat-form-field>
    </div>
    <div class='form-group'>
      <mat-form-field class='w-100'>

        <input placeholder='Password' matInput type='password' name='password' [(ngModel)]='password' id='password'>
      </mat-form-field>

    </div>
    <div class='alert alert-danger' role='alert' [hidden]='!loginMessage'>
      {{loginMessage}}
    </div>
    <button type='button' class='btn btn-primary' (click)='signIn()'>Sign In</button>
    <button routerLink='/register' type='button' class='btn btn-outline-primary mx-1'>Register</button>
    <div class='mt-2'>
      <a href='/reset-password'>Forgot your password?</a>
    </div>
  </div>

</div>
